import React, { ReactNode } from "react";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";
import Button from "./Button";
import ToggleSwitch from "./ToggleSwitch";
import theme from "../../theme";

interface Props {
  header?: string;
  content: ReactNode[];
  switchFunction?: { state: boolean; toggleSwitch: (checked: boolean) => void };
  editFunction?: () => void;
}

const InfoBoxGroup: React.FC<Props> = (props) => {
  const { header, content, switchFunction, editFunction } = props;

  const handleSwitch = (checked: boolean) => {
    switchFunction?.toggleSwitch(checked);
  };

  const xs = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Paper
      sx={{
        padding: "20px",
        marginBottom: xs ? 2 : 5,
        overflow: "unset",
        boxSizing: "border-box",
      }}
    >
      {(!!header || !!switchFunction || !!editFunction) && (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
          marginBottom={3}
        >
          <Box display="flex" flexDirection="row" alignItems="center" gap={4}>
            {!!header && <Typography variant="h4">{header}</Typography>}
            {!!switchFunction && (
              <ToggleSwitch
                label={!!switchFunction.state ? "Enabled" : "Disabled"}
                toggled={switchFunction.state}
                handleChange={handleSwitch}
              />
            )}
          </Box>
          <Box>
            {!!editFunction && (
              <Button
                label="Edit"
                variant="contained"
                color="info"
                disabled={!!switchFunction && !switchFunction?.state}
                onClick={editFunction}
                tooltip={
                  !!switchFunction && !switchFunction?.state
                    ? "Enable Toggle to Make Changes"
                    : undefined
                }
              />
            )}
          </Box>
        </Box>
      )}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: "repeat(auto-fit, minmax(200px, 1fr))",
          },
          gap: "15px",
          width: "100%",
        }}
      >
        {content}
      </Box>
    </Paper>
  );
};

export default InfoBoxGroup;
